import React, { Component } from "react";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Typography from '@material-ui/core/Typography';
import {
    SetBenutzer,
    SaveSettings,
    SetBenutzerName,
    SetPrivilegedUser,
    SetPrivilegedUserMenu
} from "../actions/SettingsActions";
import { GetListOfDrivers } from '../actions/TaskActions';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
    SuccessIcon,
} from "../bundles/IconsBundle";
import { ServerUri } from "../settings";
import { setTitle } from "../actions/AppActions";
import { Text } from '../extensions/LangaugeContainer';

const styles = {
    wrapper : {
        textAlign: 'center',
        width: '100%'
      },
    icon:{
        color: '#00B0DE'
      },
    label:{
        padding: '10px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#666666',
        fontWeight: 'bold'
    },
    notify: {
        display: 'block',
        width:"60%",
        marginLeft: '20%',
        padding: '25px',
        marginTop: '22px',
        textAlign: 'left',
        borderRadius:"3px",
        boxShadow:"0px 1px 0.5px 0.5px rgba(0.2,0.2,0.2,0.2)"
      }
  }

class Einshtellungen extends Component {

    // state = {
    //     checked: false,
    //     CurrentUserId : "",
    //     CurrentUserName: ""
    // }

    componentDidMount() {
        this.props.setTitle(<Text tid="settings"/>);
      }

    handleChange = async e => {
        switch (e.target.name) {
            case "BenutzerName":
                this.props.SetBenutzerName(e.target.value);
                this.checkUserName(e.target.value);

                return;
            default:
                return;
        }
    };

    checkUserName = async (name) => {
        if(name === ""){
            const newData = {
                checked: false,
                CurrentUserId: "",
            }
            this.props.SetBenutzer(newData);
        }else{
            await fetch(ServerUri + "/api/Berater/?name=" + name, {
                method:"GET",
            })
                .then(response => {
                    if(response.status === 200){
                        return response.json();
                    }else{
                        return false;
                    }
                })
                .then(data => {
                    if(data.success === "true"){
                        //this.setState({...this.state, checked: true, CurrentUserId: data.Id, CurrentUserName: data.Name});
                        const newData = {
                            checked: true,
                            CurrentUserId: data.Id,
                            CurrentUserName: data.Name,
                            CurrentIDBerater: data.IDBerater
                        }
                        this.props.SetBenutzer(newData);
                        if(data.privilegedUser === "yes"){
                            this.props.GetListOfDrivers();
                        }
                        this.props.SetPrivilegedUserMenu(data.privilegedUser === "yes" ? true : false);   

                        //return console.log(newData);
                    }else {
                        const newData = {
                            checked: false,
                            CurrentUserId: data.Id,
                        }
                        this.props.SetBenutzer(newData);
                        this.props.SetPrivilegedUserMenu(data.privilegedUser === "yes" ? true : false);   
                    }
                })
                .catch(function (err){
                    this.props.SetPrivilegedUserMenu(false);   
                    return console.log(err);
            });
        }

    }

    onSaveAllSettings = e => {
        this.props.SaveSettings(this.props.settings);
    };

    render() {
        return (
            <div style={styles.wrapper}>
                <div>
                    <div style={styles.label}><Text tid="settings"/></div>
                    <TextField
                       id="user_id"
                       label={<Text tid="userName"/>}
                       textalign="left"
                       marginleft="20%"
                       name="BenutzerName"
                       style = {{width: "60%"}}
                       value={this.props.settings.CurrentUserName || ""}
                       onBlur={this.onSaveAllSettings}
                       onChange={this.handleChange}
                       InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" >
                            <SuccessIcon style={{color: '#00B0DE', display: this.props.settings.checked ? "block" : "none"}} />
                          </InputAdornment>
                        ),
                      }}
                    />

                <div style={styles.notify}>
                    <div>
                        <Typography>
                        <Text tid="settingsMessage"/>
                            {/* Hinweis: Sie benötigen eine internetverbindung um die einstellungen zu erhalten */}
                        </Typography>
                    </div>
                </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => ({
    settings: state.settings
});

export default connect(
    mapStateToProps, { SetBenutzer, SetBenutzerName, SaveSettings, setTitle, GetListOfDrivers, SetPrivilegedUser, SetPrivilegedUserMenu}
)(Einshtellungen);






